{
  const modal = document.querySelector('[data-omnio-modal]');
  const closeTriggers = document.querySelectorAll('[data-omnio-modal-close]');
  const openModal = document.querySelectorAll('[data-modal-open]');
    
  [...openModal].forEach((trigger) => {
    trigger.addEventListener('click', () => {
      modal.classList.add('modal--open');
      document.body.classList.add('overflow-hidden');
    });
  });
  function allClose() {
	modal.classList.remove('modal--open');
	document.body.classList.remove('overflow-hidden');
  }
  [...closeTriggers].forEach((trigger) => {
    trigger.addEventListener('click', () => {
      allClose();
    });
  });
  
  const modalVideo = document.querySelectorAll('[data-video-modal]');
    
  [...modalVideo].forEach((videoWindow) => {
	if (videoWindow) {
      videoWindow.addEventListener('click', () => {
      const player = document.querySelector('[data-video]');
	  playerjs.api("pause");	 
	  playerManual.api("pause");	
      });
	}
  });
  
}
